import { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import { Link } from "react-router-dom";
import { currencySymbol } from "shared/CurrencySymbol";
import moment from "moment";
import Badge from "shared/Badge/Badge";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
export interface StayCardV2Props {
  className?: string;
  data?: StayDataType;
  size?: "default" | "small";
}

const DATA = DEMO_STAY_LISTINGS[0];

const StayCardV2: FC<StayCardV2Props> = ({
  size = "default",
  className = "",
  data = DATA,
}) => {
  const {
    place_images,
    address,
    title,
    href,
    price,
    id,
    state,
    check_in_date,
    check_out_date,
    guest_count,
    PropertyStatus,
    RoomName,
    RequestBy,
    roomsCount
  } = data;
  const { currentUser } = useSelector((state: RootState) => state.user);

  const modifiedPropertyStatus = (
    PropertyStatus: string | undefined | boolean
  ) => {
    const status =
      typeof PropertyStatus === "boolean"
        ? PropertyStatus.toString()
        : PropertyStatus;
    switch (status) {
      case "true":
        return "Shared Property";
      case "false":
        return "Entire Property";
      default:
        return "";
    }
  };

  const getStatusBadge = (state: string | undefined) => {
    switch (state) {
      case "send_message":
        return {
          label: "Send message",
          className: "bg-yellow-100 text-yellow-800",
        };
      case "booking_invitation":
        return {
          label: "Booking invitation",
          className: "bg-blue-100 text-blue-800",
        };
      case "rejected":
        return {
          label: "Rejected",
          className: "bg-red-100 text-red-800",
        };
      case "request_change":
        return {
          label: "Request change",
          className: "bg-orange-100 text-orange-800",
        };
      default:
        return {
          label: "",
          className: "",
        };
    }
  };
  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`StayCard_${id}`}
          ratioClass="aspect-w-4 aspect-h-3 "
          galleryImgs={place_images}
          href={href}
        />
        {/* <BtnLikeIcon isLiked={like} className="absolute right-3 top-3 z-[1]" /> */}
        {/* {saleOff && <SaleOffBadge className="absolute left-3 top-3" />} */}
        {state && (
          <div
            className={`absolute left-3 top-3 z-[1] px-4 py-1 rounded-md text-xs font-medium ${getStatusBadge(state).className
              }`}
          >
            {getStatusBadge(state).label}
          </div>
        )}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Badge
              name={modifiedPropertyStatus(PropertyStatus) || "Property"}
              className="text-xs font-normal"
            />
          </div>
          <div className="flex items-center space-x-2">
            <h2
              className={` font-medium capitalize ${size === "default" ? "text-sm" : "text-base"
                }`}
            >
              <span className="line-clamp-1">{title}</span>
            </h2>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            {size === "default" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
            <span className="">{address}</span>
          </div>
        </div>
        <hr />
        {(PropertyStatus === true || PropertyStatus === "true") && (
          <div className="flex">
            <div className="flex items-center">
              <>
                <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                  Room Name :
                </span>
                <div className="text-sm font-semibold line-clamp-1">
                  {RoomName || "N/A"}
                </div>
              </>
            </div>
          </div>
        )}
        {(PropertyStatus !== true && PropertyStatus !== "true") && (
          <div className="flex">
            <div className="flex items-center">
              <>
                <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                 Total Rooms :
                </span>
                <div className="text-sm font-semibold line-clamp-1">
                  {roomsCount || "N/A"}
                </div>
              </>
            </div>
          </div>
        )}
        {currentUser?.is_host && (
          <div className="flex">
            <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              Request by :
            </span>
            {size === "default" && (
              <span className="text-sm font-semibold">{RequestBy}</span>
            )}
          </div>
        )}
        <div className="flex">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Period :
          </span>
          {size === "default" && (
            <span className="text-sm font-semibold">
           
{moment.utc(check_in_date).local().format("MMM DD, YYYY")} to{" "}
{moment.utc(check_out_date).local().format("MMM DD, YYYY")}
            </span>
          )}
        </div>
        <div className="flex">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Guest :
          </span>
          {size === "default" && (
            <span className="text-sm font-semibold">{guest_count}</span>
          )}
        </div>
        <div className="flex">
          <span className="min-w-[110px] text-sm text-neutral-500 dark:text-neutral-400 font-normal">
            Amount :
          </span>
          <span className="text-sm font-semibold">
            {currencySymbol()}
            {Number(price)?.toFixed(2) || "N/A"}
            /Month
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard"
    >
      {renderSliderGallery()}
      <Link to={href}>{renderContent()}</Link>
    </div>
  );
};

export default StayCardV2;
